export const PRE_QUESTIONS = 'PRE_QUESTIONS';

export const preQuestions = (data) => {
	return {
		type: PRE_QUESTIONS,
		preQuestionData: data
	}
};
